import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "../../../redux/reducers/Models";
import { vehicleTypes } from "@/utils/functions";
import RegisterVehicleView from "./view";
import { useNavigate } from "react-router-dom";
import { setCustomer } from "@/redux/ducks/customer";
import useVehicles from "@/hooks/register/useVehicles";
import { PropsSet, PropsView } from "../Models/vehicle";
import useVehicleForm from "../../../hooks/useVehicleForm";
import { useCallback, useState } from "react";

export default function RegisterVehicle() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const { requestBrands, requestModels, data, setData, isLoadingOrdering } =
    useVehicles();

  const [vehicleInfos, setVehicleInfos] = useState<{
    brandName?: string;
    modelName?: string;
  } | null>(null);

  const resetFields = useCallback(
    (
      fields: string[],
      set: PropsSet["set"],
      field?: { name: string; value: string },
    ) => {
      dispatch(
        setCustomer({
          ...customer,
          register: {
            ...customer?.register,
            vehicle: {
              ...customer?.register?.vehicle,
              ...fields?.reduce(
                (acc, item) => {
                  setData(`${acc[item]}s`, null);
                  set(`${item as "type" | "brand" | "model"}`, "0", {
                    shouldValidate: true,
                  });
                  acc[item] = undefined;
                  return acc;
                },
                {} as Record<string, any>,
              ),
              ...(field ? { [field.name]: field.value } : {}),
            },
          },
        }),
      );
    },
    [dispatch, customer, setData],
  );

  const {
    toggleModal,
    isVisibleModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    errors,
    handlePlate,
    retryCreateUser,
    error,
    errorCreateUser,
    errorCustomer,
    errorPlate,
    control,
    setValue,
  } = useVehicleForm({
    navigate,
    resetFields,
    vehicleInfos: vehicleInfos!,
  });

  const goBack = () => navigate(-1);

  const goToLogin = () => navigate("/");

  const onChangeSelect: PropsView["onChangeSelect"] = ({ e, onChange }) => {
    onChange(e);

    const { name, value, options, selectedIndex } = e.target;

    const text = options?.[selectedIndex]?.text;

    const vehicle = customer?.register?.vehicle;

    let fields: string[] = [];

    switch (name) {
      case "type":
        fields = ["brand", "model"];
        if (value !== "0") {
          requestBrands(value);
        }
        break;

      case "brand":
        fields = ["model"];
        if (value !== "0") {
          setVehicleInfos((prev) => ({ ...prev, brandName: text }));
          requestModels(vehicle?.type!, value);
        }
        break;

      case "model":
        if (value !== "0") {
          setVehicleInfos((prev) => ({ ...prev, modelName: text }));
        }
        break;

      default:
        break;
    }

    resetFields(fields, setValue as PropsSet["set"], e.target);
  };

  return (
    <RegisterVehicleView
      goBack={goBack}
      onChangeSelect={onChangeSelect}
      goToLogin={goToLogin}
      isDisabled={isDisabled}
      types={vehicleTypes}
      brands={data?.brands as PropsView["brands"]}
      models={data?.models as PropsView["models"]}
      isLoading={isLoading || isLoadingOrdering}
      error={error}
      errorPlate={errorPlate}
      errorCustomer={errorCustomer}
      errorCreateUser={errorCreateUser}
      handlePlate={handlePlate}
      retryCreateUser={retryCreateUser}
      register={register}
      errors={errors}
      handleSubmit={handleSubmit}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
      control={control}
    />
  );
}
